import { nextTick, onMounted, onActivated } from "vue";
const useMountedOrActivated = (hook) => {
  let mounted;
  onMounted(() => {
    hook();
    nextTick(() => {
      mounted = true;
    });
  });
  onActivated(() => {
    if (mounted) {
      hook();
    }
  });
};
export {
  useMountedOrActivated
};
